<template>
  <div id="contenedor-planeacion-toolbar">
    <v-toolbar flat dense>
      <div style="width: 150px" class="mr-2">
        <ejercicio-picker
        v-model="filtros.ejercicio"
        class="mr-2">
        </ejercicio-picker>
      </div>
      <div style="width: 350px" class="mr-2">
        <custom-text-field
          label="Buscar..."
          append-icon="mdi-magnify"
          clearable
          @keyup="buscar"
          @click:clear="limpiarBuscadorTexto"
        >
        </custom-text-field>
      </div>
      <filtros
        :obras="listaObras"
        :filtros="filtros">
      </filtros>
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Nuevo"
        iconText="mdi-plus"
        tipo="agregar"
        @click="nuevo"
      >
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import Filtros from './Filtros.vue';
import CustomButton from '@/components/buttons/Button.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'ToolBarPlaneacion',
  props: {
    listaObras: {
      type: Array,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    Filtros,
    CustomButton,
    EjercicioPicker,
    CustomTextField,
  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
    nuevo() {
      this.$emit('nuevaObra');
    },
  },
};
</script>

<style lang="scss">
</style>
